'use client';

import { useEffect } from 'react';
import { Inter, JetBrains_Mono } from 'next/font/google';
import ErrorSection from '@/components/sections/utils/Error/Error';
import '@/styles/globals.css';

const inter = Inter({
  subsets: ['latin', 'cyrillic'],
  variable: '--font-inter',
  display: 'swap',
});

const jetBrainsMono = JetBrains_Mono({
  subsets: ['latin'],
  variable: '--font-jetBrainsMono',
  display: 'swap',
});

const fallbackErrorDict = {
  title: '500',
  subtitle: 'Something went wrong',
  description:
    'We apologize for the inconvenience. An unexpected error occurred.',
  button: 'Try again',
};

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="en" className={`${jetBrainsMono.variable} ${inter.variable}`}>
      <body>
        <main>
          <ErrorSection dict={fallbackErrorDict} reset={reset} />
        </main>
      </body>
    </html>
  );
}
